"use client";

import { useState, useEffect } from "react";
import {
  Button,
  Tag,
  Input,
  Space,
  Typography,
  Grid,
  Divider,
  message,
} from "antd";
import {
  EditOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  PlusOutlined,
  SolutionOutlined,
  ScissorOutlined,
  ClockCircleOutlined,
  SearchOutlined,
  CloseOutlined,
  MedicineBoxOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { addsymptom, getsymptom } from "../../services/doctor/symptom/symptom";
import {
  addFinding,
  getFindings,
} from "../../services/doctor/findings/findings";
import {
  addDiagnoses,
  getDiagnoses,
} from "../../services/doctor/diagnoses/diagnoses";
import {
  addmedicine,
  getmedicine,
} from "../../services/doctor/medicine/medicine";
import {
  addInvestigation,
  getInvestigations,
} from "../../services/doctor/investigation/investigation";
import {
  addInstruction,
  getInstruction,
} from "../../services/doctor/instruction/instruction";
import {
  addProcedure,
  getProcedure,
} from "../../services/doctor/procedure/procedure";
import { useAuth } from "../../services/authentication_API/authService";
import AddModal from "../doctorSettings/AddModal";
import MedicineForm from "../doctorSettings/MedicineForm";
import MedicineModal from "../doctorSettings/MedicineFormForConsultant";

const { useBreakpoint } = Grid;
const { Text, Title } = Typography;

const sectionIcons = {
  symptoms: { icon: <FileSearchOutlined />, color: "#ff4d4f" },
  findings: { icon: <SearchOutlined />, color: "#faad14" },
  diagnosis: { icon: <SolutionOutlined />, color: "#1890ff" },
  medicines: { icon: <MedicineBoxOutlined />, color: "#52c41a" },
  investigations: { icon: <FileTextOutlined />, color: "#13c2c2" },
  instructions: { icon: <EditOutlined />, color: "#722ed1" },
  procedures: { icon: <ScissorOutlined />, color: "#eb2f96" },
};

export default function SectionManagerLi({
  activeSection1,
  iteam,
  sections,
  onItemSelect,
  onIteamRemove,
  autoSave,
  refresh,
  setShowSidebar,
  setSearchQuery1,
}) {
  const screens = useBreakpoint();
  const [searchQuery, setSearchQuery] = useState("");

  const { userData } = useAuth();

  // New state to track if the search input is focused
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  const [sectionState, setSectionState] = useState(() => {
    const sectionsData = { ...sections?.section };
    Object.keys(sectionsData).forEach((sectionId) => {
      delete sectionsData[sectionId].selectedItems;
    });
    return sectionsData;
  });
  const [activeSection, setActiveSection] = useState(
 iteam[0]
  );
  const [filteredItems, setFilteredItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [medicineName, setMedicineName] = useState("");
  const [showInvestigationModal, setShowInvestigationModal] = useState(false);
  const [InvestigationName, setInvestigationName] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const [edit, setEdit] = useState(false);
  const [editData, setEditData] = useState(null);



  const searchItem = async (query) => {
    switch (activeSection) {
      case "symptoms": {
        const result = await getsymptom(query, userData.id);
        setFilteredItems(result?.data || []);
        break;
      }
      case "findings": {
        const result = await getFindings(query);
        setFilteredItems(result?.data || []);
        break;
      }
      case "diagnosis": {
        const result = await getDiagnoses(query);
        setFilteredItems(result?.data || []);
        break;
      }
      case "medicines": {
        const result = await getmedicine(query, userData.id);
        setFilteredItems(result?.data || []);
        break;
      }
      case "investigations": {
        const result = await getInvestigations(query);
        setFilteredItems(result?.data || []);
        break;
      }
      case "instructions": {
        const result = await getInstruction(query);
        setFilteredItems(result?.data || []);
        break;
      }
      case "procedures": {
        const result = await getProcedure(query);
        setFilteredItems(result?.data || []);
        break;
      }
      default:
        break;
    }
  };

  useEffect(() => {
    console.log("Active Section changed to:", activeSection);
    if (!activeSection) return; // No section selected

    if (searchQuery.length >= 3) {
      console.log("Searching for:", searchQuery, "in section:", activeSection);
      // Fetch from backend
      searchItem(searchQuery);
    } else {
      const filtered = sectionState[activeSection];
      setFilteredItems(filtered);
    }
  }, [searchQuery, activeSection]);

  const handleAdd = async (name) => {
    const form = { name };
    console.log(form);
    let result;
    switch (activeSection) {
      case "symptoms": {
        result = await addsymptom(form);
        break;
      }
      case "findings": {
        result = await addFinding(form);
        break;
      }
      case "diagnosis": {
        result = await addDiagnoses(form);
        break;
      }
      case "medicines": {
        setMedicineName(name);

        setShowModal(true);
        break;
      }
      case "investigations": {
        setInvestigationName(name);
        setShowInvestigationModal(true);

        break;
      }
      case "instructions": {
        result = await addInstruction(form);
        break;
      }
      case "procedures": {
        result = await addProcedure(form);
        break;
      }
      default:
        messageApi.error("Something went wrong");
        break;
    }
    console.log("result after add item ", result);
    if (result?.success) {
      messageApi.open({
        type: "success",
        content: `${activeSection} add successfully!`,
      });
      setSearchQuery("");
      setSearchQuery1("");

      const result1 = onItemSelect(activeSection, result?.data);
      setSelectedItems(result1);
    } else {
      result?.error?.name?.forEach((element) => {
        messageApi.error(element || "Something went wrong");
      });
    }
  };
  const handleClose = (data) => {
    console.log("add modal closed ", data);
    if (data != null && data != undefined) {
      const result1 = onItemSelect(activeSection, data);

      setSelectedItems(result1);
      setSearchQuery("");
      setSearchQuery1("");
    }
    setShowModal(false);
    setShowInvestigationModal(false);
    // refresh(prev => !prev);
  };

  const handleEdit = (data) => {
    setEdit(true);
    setEditData(data);
  };

  // Responsive styles

  const searchInputStyle = {
    marginBottom: screens.xs ? 8 : 12,
    width: "100%",
    height: "50px",
    padding: "0 0 0 11px",
  };

  const tagStyle = {
    padding: screens.xs ? "3px 9px" : "15px 15px",
    borderRadius: "30px 30px 30px 30px",
    marginBottom: screens.xs ? 4 : 8,
    marginRight: screens.xs ? 4 : 8,
    fontSize: screens.xs ? "1rem" : "1.2rem",
    maxWidth: "100%",
    whiteSpace: "normal",
    wordBreak: "break-word",
    fontWeight: "bold",
    borderWidth: "2px",
    borderStyle: "solid",
    color: "#474646ff",
    transition: "all 0.3s ease-in-out",
  };

  const selectedTagStyle = {
    ...tagStyle,
    backgroundColor: "#e6f4ff",
    color: "#0958d9",
    borderColor: "#91caff",
  };

  const unselectedTagStyle = {
    ...tagStyle,
    cursor: "pointer",
    ":hover": {
      transform: "scale(1.02)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
    WebkitTouchCallout: "none", // Disable long press menu (iPad/iPhone)
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
    userSelect: "none",
  };

  const itemsContainerStyle = {
    overflowY: "visible", // Change to visible as the parent div handles scroll
    overflowX: "hidden",
  };
  const tabLinkStyle = (key) => ({
    padding: "8px 6px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: screens.xs ? "1rem" : "1.2rem",
    color: activeSection === key ? "#1890ff" : "#555",
    borderBottom:
      activeSection === key ? "3px solid #1890ff" : "3px solid transparent",
    transition: "all 0.2s ease-in-out",
  });

 

  return (
    <>
      {contextHolder}
      <div
        style={{
          height: "100%",
          flexDirection: "column",
          overflowY: "auto",
          overflowX: "hidden",

          // padding: screens.xs ? "16px 8px" : "24px 16px",
        }}
      >
        {/* Navigation Controls - Wrapped for smooth hide/shrink */}
        <div
          style={{
            maxHeight: isSearchFocused ? "0" : "60px",
            opacity: isSearchFocused ? "0" : "1",
            overflow: "hidden",
            transition: "max-height 0.3s ease-out, opacity 0.3s ease-out", // Transition applied here
          }}
        >
          <div
            style={{
              // --- MODIFIED STYLE HERE ---
              display: "flex",
              justifyContent: "space-around", // Changed from "flex-start" to distribute tabs equally
              alignItems: "center",
              marginBottom: "12px",
              borderBottom: "1px solid #f0f0f0",
              width: "100%", // Ensure the container spans full width
            }}
          >
            {iteam.map((tab) => (
              <div
                key={tab}
                // Optional: Add flex-grow: 1 to each tab if you want them to occupy equal width slots
                style={{
                  ...tabLinkStyle(tab),
                  flexGrow: 1,
                  textAlign: "center", // Center the text within each tab slot
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  setActiveSection(tab);
                  setSearchQuery("");
                  setSearchQuery1("");
                  setShowSidebar(false);
                }}
              >
                {tab}
              </div>
            ))}
          </div>
        </div>

        {/* Search Input */}
        <Input
          placeholder={`Search ${activeSection}...`}
          prefix={
            <SearchOutlined
              style={{
                color: "#000000ff",
                fontSize: screens.xs ? "16px" : "25px",
              }}
            />
          }
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value),
              setSearchQuery1(e.target.value),
              setShowSidebar(false);
          }}
          onPressEnter={(e) => handleAdd(searchQuery)}
          style={searchInputStyle}
          // Handlers to toggle the focus state
          onFocus={() => setIsSearchFocused(true)}
          onBlur={() => {
            setTimeout(() => {
              setIsSearchFocused(false);
            }, 200);
          }}
          suffix={
            searchQuery.length >= 3 && (
              <Button
                type="primary"
                size="large" // Changed from "small" to help match height
                icon={<PlusOutlined />}
                style={{
                  height: "100%",
                  padding: screens.xs ? "0 10px" : "0 14px",
                  fontSize: screens.xs ? "16px" : "18px",
                  borderRadius: "0 6px 6px 0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent parent click handlers
                  handleAdd(searchQuery);
                }}
              />
            )
          }
          size="large"
        />

        {/* Selected Items - Wrapped for smooth hide/shrink */}
        {sections[activeSection]?.length > 0 && (
          <div
            style={{
              marginBottom: 5,
              maxHeight: isSearchFocused ? "0" : "100%",
              opacity: isSearchFocused ? "0" : "1",
              overflow: "hidden",
              transition: "max-height 0.3s ease-out, opacity 0.3s ease-out",
            }}
          >
            <div
              style={{
                // Changed from flex-wrap to block/column layout
                display: "block",
              }}
            >
              {sections[activeSection]?.map((item) => (
                <div key={item.id}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: screens.xs ? "12px 8px" : "16px 12px", // Increased padding for list feel
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      const result = onItemSelect(activeSection, item);
                      setSelectedItems(result);
                    }}
                  >
                    <Text
                      strong
                      style={{
                        fontSize: screens.xs ? "1rem" : "1.1rem",
                        color: "#000",
                        flexGrow: 1,
                      }}
                    >
                      {item.name}
                    </Text>
                    {/* The CloseOutlined icon for removal */}
                    <span
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const result = onIteamRemove(activeSection, item.name);
                        setSelectedItems(result);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        marginLeft: "10px",
                      }}
                    >
                      <CloseOutlined
                        style={{
                          fontSize: screens.xs ? "16px" : "20px",
                          color: "#ff4d4f", // Red color for removal action
                        }}
                      />
                    </span>
                  </div>
                  {/* Add Ant Design Divider */}
                  <Divider
                    style={{ margin: "0", borderTop: "1px solid #f0f0f0" }}
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* All Items */}
        <div style={itemsContainerStyle}>
          <div
            style={{
              // Changed from flex-wrap to block/column layout
              display: "block",
            }}
          >
            {filteredItems?.map((item) => {
              const isSelected = sections[activeSection]?.some(
                (selectedItem) => selectedItem?.name === item?.name
              );

              // Only display unselected items
              return isSelected ? null : (
                <div key={item?.id}>
                  <div
                    // Add long press and click handlers to the div wrapper
                    onMouseDown={(e) => {
                    // Start press timer
                    e.stopPropagation();
                    const timer = setTimeout(() => {
                      handleEdit(item); // ← your edit function
                    }, 600); // Hold duration

                    // Save timer ref
                    e.target.pressTimer = timer;
                  }}
                  onMouseUp={(e) => {
                    // If hold didn't complete → treat as normal click
                    clearTimeout(e.target.pressTimer);
                  }}
                  onMouseLeave={(e) => {
                    // Cancel when pointer moves out
                    clearTimeout(e.target.pressTimer);
                  }}
                    onClick={(e) => {
                    if (e.target.longPressTriggered) {
                      e.stopPropagation();
                      e.target.longPressTriggered = false;
                      return;
                    } e.stopPropagation();
                      const result = onItemSelect(activeSection, item);
                      setSelectedItems(result);
                      setShowSidebar(false);
                      setSearchQuery("");
                    }}
                    onTouchStart={(e) => {
                    e.preventDefault(); // Stop iPad text highlight + selection
                    const timer = setTimeout(() => {
                      handleEdit(item);
                    }, 600);
                    e.target.pressTimer = timer;
                  }}
                  onTouchEnd={(e) => {
                    clearTimeout(e.target.pressTimer);
                  }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: screens.xs ? "12px 8px" : "16px 12px",
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                      // Add a hover effect for better UX
                      ":hover": { backgroundColor: "#807777ff" },
                    }}
                  >
                    <Text
                      style={{
                        fontSize: screens.xs ? "1rem" : "1.1rem",
                        color: "#474646ff",
                      }}
                    >
                      {item?.name}
                    </Text>
                  </div>
                  {/* Add Ant Design Divider */}
                  <Divider
                    style={{ margin: "0", borderTop: "1px solid #f0f0f0" }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {showModal && (
        <MedicineModal
          show={showModal}
          type="add"
          onHide={handleClose}
          name={medicineName}
        />
      )}
      {showInvestigationModal && (
        <AddModal
          show={showInvestigationModal}
          onHide={handleClose}
          refresh={() => null}
          type="Investigations"
          isedit={false}
        />
      )}
      {activeSection != "medicines" && (
        <AddModal
          show={edit}
          onHide={() => {
            setEdit(false);
          }}
          refresh={refresh}
          type={activeSection}
          isedit={true}
          data={editData}
        />
      )}
      {activeSection == "medicines" && (
        <MedicineForm
          show={edit}
          onHide={() => {
            setEdit(false);
          }}
          refresh={refresh}
          type="edit"
          record={editData}
        />
      )}
    </>
  );
}

SectionManagerLi.propTypes = {
  activeSection1: PropTypes.string,
  sections: PropTypes.object.isRequired,
  onItemSelect: PropTypes.func.isRequired,
  onIteamRemove: PropTypes.func.isRequired,
  setShowSidebar: PropTypes.func.isRequired,
  autoSave: PropTypes.func,
  setSearchQuery1: PropTypes.func,
  iteam: PropTypes.array,
  refresh: PropTypes.func,
};
